/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchUser } from 'shared/services/fetchUser';
import { setUserData } from 'shared/slices/user';
import { IThunkApi } from 'shared/types/redux';

export const getUser = createAsyncThunk<void, void, IThunkApi>('user/getUser', async (_, thunkApi) => {
  const { extra: context, dispatch } = thunkApi;

  const user = await fetchUser(context, { parameters: {} });

  dispatch(setUserData(user));
});
